/* TD vertical-scroll discoverability: active drawer only; no gesture overrides. */
(function () {
  'use strict';
  var media = window.matchMedia('(pointer: coarse), (max-width: 1024px)');
  var active = null;
  var scrollArea = null;
  var host = null;
  var cue = null;
  var rail = null;
  var thumb = null;
  var resizeObserver = null;
  var contentObserver = null;
  var frame = 0;

  function cleanup() {
    if (frame) { cancelAnimationFrame(frame); frame = 0; }
    if (scrollArea) scrollArea.removeEventListener('scroll', schedule);
    if (resizeObserver) { resizeObserver.disconnect(); resizeObserver = null; }
    if (contentObserver) { contentObserver.disconnect(); contentObserver = null; }
    if (cue) cue.remove();
    if (rail) rail.remove();
    if (host) host.classList.remove('td-vscroll-host');
    active = scrollArea = host = cue = rail = thumb = null;
  }

  function findTarget() {
    if (!media.matches) return null;
    // Custom overlay is above standard Impulse drawers when both exist.
    var overlay = document.querySelector('overlay-drawer[open="true"]');
    if (overlay) {
      var inner = overlay.querySelector('.overlay-drawer__inner');
      if (inner && inner.clientHeight > 0) return { drawer: overlay, scroll: inner, host: overlay };
    }
    var drawers = document.querySelectorAll('.drawer.drawer--is-open');
    for (var i = drawers.length - 1; i >= 0; i--) {
      var regions = drawers[i].querySelectorAll('.drawer__scrollable');
      for (var j = 0; j < regions.length; j++) {
        if (regions[j].clientHeight > 0 && regions[j].getClientRects().length) {
          return { drawer: drawers[i], scroll: regions[j], host: regions[j].parentElement };
        }
      }
    }
    return null;
  }

  function update() {
    frame = 0;
    if (!active || !scrollArea || !host || !host.isConnected) { sync(); return; }
    var current = findTarget();
    if (!current || current.drawer !== active || current.scroll !== scrollArea) { sync(); return; }
    var available = scrollArea.scrollHeight - scrollArea.clientHeight;
    var visible = available > 28 && scrollArea.clientHeight > 100;
    cue.classList.toggle('is-visible', visible && (available - scrollArea.scrollTop > 12));
    rail.classList.toggle('is-visible', visible);
    if (!visible) return;

    var h = host.getBoundingClientRect();
    var s = scrollArea.getBoundingClientRect();
    if (!s.width || !s.height) return;
    // Position over the scrolling region, never over the fixed checkout/footer.
    cue.style.bottom = Math.max(8, Math.round(h.bottom - s.bottom + 10)) + 'px';
    cue.style.right = Math.max(8, Math.round(h.right - s.right + s.width / 2 - 19)) + 'px';
    rail.style.right = Math.max(5, Math.round(h.right - s.right + 5)) + 'px';
    rail.style.top = Math.round(s.top - h.top + Math.max(10, (s.height - 58) / 2)) + 'px';
    var ratio = Math.max(0, Math.min(1, scrollArea.scrollTop / available));
    thumb.style.transform = 'translateY(' + Math.round(34 * ratio) + 'px)';
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function sync() {
    var next = findTarget();
    if (next && next.drawer === active && next.scroll === scrollArea) { schedule(); return; }
    cleanup();
    if (!next) return;
    active = next.drawer;
    scrollArea = next.scroll;
    host = next.host;
    host.classList.add('td-vscroll-host');
    cue = document.createElement('div');
    cue.className = 'td-vscroll-cue';
    cue.setAttribute('aria-hidden', 'true');
    cue.textContent = '↓';
    rail = document.createElement('div');
    rail.className = 'td-vscroll-rail';
    rail.setAttribute('aria-hidden', 'true');
    thumb = document.createElement('span');
    rail.appendChild(thumb);
    host.appendChild(cue);
    host.appendChild(rail);
    scrollArea.addEventListener('scroll', schedule, { passive: true });
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(schedule);
      resizeObserver.observe(scrollArea);
      Array.prototype.forEach.call(scrollArea.children, function (node) {
        if (node !== cue && node !== rail) resizeObserver.observe(node);
      });
    }
    // Observe only the active scroll region; async cart/wishlist/accordion changes.
    contentObserver = new MutationObserver(schedule);
    contentObserver.observe(scrollArea, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style'] });
    schedule();
  }

  function start() {
    document.addEventListener('drawerOpen', sync);
    window.addEventListener('resize', sync, { passive: true });
    if (media.addEventListener) media.addEventListener('change', sync);
    else if (media.addListener) media.addListener(sync);
    new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    // Observe the custom drawer's own open attribute, not the entire DOM tree.
    document.querySelectorAll('overlay-drawer').forEach(function (node) {
      new MutationObserver(sync).observe(node, { attributes: true, attributeFilter: ['open'] });
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
